console.log("the mighty typescript has been loaded! :-)");

interface Bla {
    count: number;
}


if (test === "Hi") {
    const bla: Bla = {
        count: 5
    };
}
